import React from 'react';
import ComingSoon from '../components/ComingSoon';

const Systemic = () => <ComingSoon title="Systemic Survey" />;

export default Systemic;
